import { client } from '@repo/shared-kit/utils';
import { partnerBaseURL, partnerNamespace } from '../../constants/hosts';

export async function postRegistrationSubmitAsync(registrationId: string): Promise<void> {
  await client(
    `${partnerBaseURL}/${partnerNamespace}/registrations/${registrationId}/submit_async`,
    {
      method: 'POST',
    }
  );
}
